import styled from '@emotion/styled';
import { BaseArea, BaseButton, BaseInput, BaseSelect, forPhoneOnly, PopoverItem, Variables } from '../../../base';

export const FiltersContainer = styled.section`
    display: flex;
    align-items: center;
`;

export const FilterItem = styled.div`
    flex: 1;
    margin-left: 12px;
    /* Top-aligned, so a row whose value control is taller than the others — a MultiString textarea,
       or any field showing a validation message — keeps the field and method selects on the first
       line instead of floating them to the middle of it. The row's delete button is left to the
       group's own centring. */
    align-self: flex-start;
`;

export const ActionsWrapper = styled.div`
    display: flex;
`;

/**
 * The value box of a MultiString filter.
 *
 * Soft wrapping is the thing being switched off, and it is not cosmetic. The cell is a third of a
 * 760px popover — about 240px — while a claim UUID is 36 characters, so every pasted ID wrapped
 * onto two lines and the top of a scrolled box opened mid-identifier: the first line read
 * `ca2790676a51`, a fragment of the ID above it. This box is exactly where someone checks that a
 * 50-ID paste landed intact, and wrapped halves are indistinguishable from a mangled list.
 *
 * `wrap="off"` on the element keeps one value per visual line, so the row count means what it says
 * and a truncated line scrolls instead of splitting.
 */
export const MultiValueArea = styled(BaseArea)`
    font-size: ${Variables.FontSizes.tiny};
    line-height: 20px;
    overflow-x: auto;
`;

export const FilterItemInput: any = styled(BaseInput)``;

export const FilterItemSelect: any = styled(BaseSelect)``;

export const FilterGroup = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    ${FilterItem}:first-of-type {
        margin-left: 0;
        flex: 1;
    }
`;

export const DeleteButton = styled(BaseButton)`
    width: 18px;
    height: 18px;
    padding: 0;
    min-width: auto;
    margin-left: 10px;
`;

export const AddRowButton = styled(BaseButton)`
    margin-top: 10px;
`;

export const FilterWrapper = styled(PopoverItem)`
    width: calc(800px - 2 * 20px);
    cursor: default;
    padding: 16px 20px;
    margin: 0;
    color: ${Variables.Colors.n70};
    &:hover {
        cursor: default;
        background: none;
    }

    ${FilterGroup} {
        margin-top: 10px;
    }

    ${FilterGroup}:first-of-type {
        margin-top: 0;
    }

    ${forPhoneOnly(`
        width: calc(90vw - 48px);
        & input {
            font-size: 12px;
        }
    `)};
`;

export const ActionButton = styled(BaseButton)`
    min-width: 100px; /* ensure room for icon */
    margin-right: 8px;
`;

export const ActiveFilters = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: 18px;
`;

export const FilterButton = styled(BaseButton)`
    white-space: nowrap;
    margin: 4px 16px 4px 0;
    & > svg {
        margin-left: 8px;
    }
`;

export const FilterText = styled.span`
    line-height: 18px;
    font-size: 16px;
`;

export const FilterOperator = styled.span`
    line-height: 18px;
    font-size: 18px;
`;

export const FilterInput: any = styled(BaseInput)`
    &:focus {
        transition: none;
        width: 300px;
    }
`;
